import { stepsFullPath } from "../stepsPath";
import { TherapistFields } from "../util";

export const coveredFields: TherapistFields = ["issues", "specialties"];
export const step4_1Path = "/4_1";
export const step4_1FullPath = `${stepsFullPath}${step4_1Path}`;
